import React from "react";
import { Link } from "../../../utils/customLink";
import Image from "../../../components/image";
import { useTheme } from "../../../context/ThemeContext";

import authorImg from "../../../images/blog/author.png";
import ArrowRightIcon from "../../../images/icons/arrow-right-icon.inline.svg";

const ArticleMegaCard = ({ article }) => {
  const { planetDomain } = useTheme();
  const title = article?.blogPosts?.blogFeatureTitle ?? article.title ?? "";
  const subTitle = article?.blogPosts?.blogSubtitle ?? "";
  const summary = article?.blogPosts?.blurb ?? "";
  const uri = [planetDomain, article?.uri ?? "#"].join("");
  const pubDate = article?.publishedDate ?? "#";
  const authorName = article?.author?.node?.firstName
    ? [article?.author?.node?.firstName, article?.author?.node?.lastName].join(
        " "
      )
    : "";

  const authorAvatar = article?.author?.node?.avatar?.url ?? authorImg;

  return (
    <div className="relative planet:bg-gray-dark bg-yellow-lighter">
      <div className="absolute left-0 flex items-center justify-center px-3 py-1 border-2 border-white planet:bg-gray-dark bg-gray-lighten w-max -top-[39px]">
        <span className="uppercase planet:text-white text-black-lighter text-[18px] font-heading font-semibold">
          what’s up next?
        </span>
      </div>
      <article className="px-8 py-10">
        <div
          className="sm:text-[64px] text-[26px] leading-[95%] planet:text-white text-black-lighter planet:font-bold"
          dangerouslySetInnerHTML={{ __html: title }}
        />
        <div
          className="py-6 sm:text-[38px] text-[26px] leading-[115%] font-light planet:font-body font-alice planet:text-white text-black-lighter"
          dangerouslySetInnerHTML={{ __html: subTitle }}
        />
        <div
          className="text-base planet:text-white text-black-lighter pb-6"
          dangerouslySetInnerHTML={{ __html: summary }}
        />
        <div className="relative items-end justify-between block sm:flex">
          <div className="hidden py-4 pr-10 border-b planet:border-black-tertiary border-black-lighter sm:flex justify-around items-center">
            {authorAvatar && authorName && (
              <div className="mr-3 avatar-img">
                <Image
                  imageAlt={`Article by ${authorName}`}
                  image={""}
                  imageClass="rounded-xl w-[48px] h-[48px]"
                  sourceUrl={authorAvatar}
                />
              </div>
            )}
            <div className="flex flex-col justify-center planet:text-gray-darken text-black-lighter">
              {authorName && <p className="text-sm uppercase">{authorName}</p>}
              <p className="text-xs">Posted: {pubDate}</p>
            </div>
          </div>
          <div className="mt-5 sm:mt-0">
            <Link
              className="flex items-center justify-center w-full h-10 px-10 text-base font-semibold leading-7 tracking-wider planet:rounded-sm rounded-xxxxl planet:bg-green-standard bg-red-light md:w-max planet:text-gray-darker text-white planet:text-sm text-center"
              to={uri}
            >
              <span className="mr-3 font-bold">Read the article</span>
              <ArrowRightIcon className="stroke-white planet:stroke-gray-darker" />
            </Link>
          </div>
        </div>
      </article>
    </div>
  );
};

export default ArticleMegaCard;
